import {
  REMOVE_TREATMENT_INSTANCE,
  REMOVE_COPY_TREATMENT_INSTANCE,
  REMOVE_TREATMENT_INSTANCE_COPIES,
  UPDATE_TIME_LEFT_TO_ALLOCATE,
} from '../../constants/types';

const removeTreatmentInstanceRequest = (treatmentId, assignGuid, occurrence, effectiveTimeSlots) => ({
  type: REMOVE_TREATMENT_INSTANCE,
  treatmentId,
  assignGuid,
  occurrence,
  effectiveTimeSlots,
});

export const removeTreatmentInstance = (treatmentId, assignGuid, occurrence, effectiveTimeSlots) => async dispatch => {
  await dispatch(removeTreatmentInstanceRequest(treatmentId, assignGuid, occurrence, effectiveTimeSlots));
};

export function removeCopyTreatmentInstance(assignGuid) {
  return {
    type: REMOVE_COPY_TREATMENT_INSTANCE,
    assignGuid,
  };
}

export function removeTreatmentInstanceCopies(masterId) {
  return {
    type: REMOVE_TREATMENT_INSTANCE_COPIES,
    masterId,
  };
}

export function updateTotalTimeLeftToAllocate(duration) {
  return {
    type: UPDATE_TIME_LEFT_TO_ALLOCATE,
    duration,
  };
}
